module.exports = __webpack_public_path__ + "static/media/image_empty_cart.d57d2a56.svg";